module.exports = __webpack_public_path__ + "assets/img/26_10.e8dcf4ab.jpg";